export function getStopDepartureEmptyState({
  isArrivalOnly = false,
  isTimetable = false,
  hasDirectionFilter = false,
  hasDestinationFilter = false,
  hasServicesFilter = false,
} = {}) {
  if (isArrivalOnly) {
    return {
      message: "This stop is for arrivals only.",
      showClearServicesAction: false,
    };
  }

  const prefix = isTimetable
    ? "No scheduled departures"
    : "No upcoming departures";
  const filterCount = [
    hasDirectionFilter,
    hasDestinationFilter,
    hasServicesFilter,
  ].filter(Boolean).length;

  if (filterCount === 0) {
    return {
      message: isTimetable
        ? "No scheduled departures for this day."
        : "No upcoming departures.",
      showClearServicesAction: false,
    };
  }

  if (filterCount === 3) {
    return {
      message: `${prefix} match your filters.`,
      showClearServicesAction: true,
    };
  }

  const parts = [];

  if (hasDirectionFilter) {
    parts.push("in this direction");
  }

  if (hasDestinationFilter) {
    parts.push("to your destination");
  }

  if (hasServicesFilter) {
    parts.push("for your selected services");
  }

  return {
    message: `${prefix} ${parts.join(" ")}.`,
    showClearServicesAction: hasDestinationFilter && hasServicesFilter,
  };
}
